import { createFileRoute } from "@tanstack/react-router"

// Route-depth MARKER: `/people/$guestId` activates the guest-record column
// (col 2). The People LAYOUT route (people.tsx) reads `$guestId` from the leaf
// match and renders every column itself via ColumnLayout; this child just
// contributes the param. Mirrors forms/$formId.
export const Route = createFileRoute("/$orgSlug/$eventSlug/people/$guestId")({
  component: () => null,
})
